import { DEFAULT_MAIN_PRESET, parseMainPromptPreset, type MainPromptPreset } from "./presetAssembler";
import { getSetting, putSetting } from "./db";

const KEY = "preset-library:main:v1";
export interface PresetLibrary { activeId: string; presets: MainPromptPreset[] }

export async function loadPresetLibrary(): Promise<PresetLibrary> {
  const saved = await getSetting<PresetLibrary | null>(KEY, null);
  if (!saved) return { activeId: DEFAULT_MAIN_PRESET.id, presets: [structuredClone(DEFAULT_MAIN_PRESET)] };
  const presets = saved.presets.flatMap((preset) => { try { return [parseMainPromptPreset(preset)]; } catch { return []; } });
  if (!presets.some((preset) => preset.id === DEFAULT_MAIN_PRESET.id)) presets.unshift(structuredClone(DEFAULT_MAIN_PRESET));
  return { activeId: presets.some((preset) => preset.id === saved.activeId) ? saved.activeId : DEFAULT_MAIN_PRESET.id, presets };
}

export async function savePresetLibrary(library: PresetLibrary) {
  const presets = library.presets.map(parseMainPromptPreset);
  if (!presets.some((preset) => preset.id === DEFAULT_MAIN_PRESET.id)) throw new Error("内置默认预设不能删除");
  await putSetting(KEY, { activeId: library.activeId, presets });
}
